import {Routes} from "@angular/router";
import {WorkflowEndcustomerAddTrialPhonenumberComponent} from "./workflow-endcustomer-add-trial-phonenumber.component";

export const workflowEndcustomerAddTrialPhonenumberRouting: Routes = [
    { path: 'trial-phonenumber', component: WorkflowEndcustomerAddTrialPhonenumberComponent, children: [
            { path: 'add-phonenumber', component: WorkflowEndcustomerAddTrialPhonenumberComponent, data: { step: 'add-phonenumber' } },
            { path: 'completed', component: WorkflowEndcustomerAddTrialPhonenumberComponent, data: { step: 'completed' } },
    ]},
]